import { compact, map } from 'lodash';
import Root from '../Root';
import { DocType } from '../global/Doc.enum';
import RiskInsuranceRequirements from './RiskInsuranceRequirements';
import RiskInsuranceProduct from './RiskInsuranceProduct';
import RiskInsuranceCompliance from './RiskInsuranceCompliance';
import type { IRiskInsurance } from './RiskInsurance.interface';

export default class RiskInsurance extends Root implements IRiskInsurance {
  requirements: RiskInsuranceRequirements;
  products: Array<RiskInsuranceProduct>;
  compliance: RiskInsuranceCompliance;

  static build = (data: IRiskInsurance) => new RiskInsurance(data);
  static blank = () => new RiskInsurance({ isActive: true });

  /**
   * Constructor
   * @param {IRiskInsurance} data
   */
  constructor(data?: IRiskInsurance) {
    super(DocType.of('__datum.riskinsurance'), data);

    this.requirements = new RiskInsuranceRequirements(data?.requirements);
    this.products = map(compact(data?.products), (obj) => new RiskInsuranceProduct(obj));
    this.compliance = new RiskInsuranceCompliance(data?.compliance);
  }
}
